import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { Channel } from '~core/models/channel.models';

@Component({
  selector: 'subscriber-channel-datatable',
  standalone: false,
  templateUrl: './subscriber-channel-datatable.component.html',
  styleUrl: './subscriber-channel-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberChannelDatatableComponent extends BaseComponent {
  channels = input<Channel[]>([]);

  displayedColumns: string[] = ['mediaType', 'name', 'totalExpenses'];
}
